import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import Images from "@Theme/Images";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import InputField, { InputTitle } from "@Molecule/InputField";
import { Box } from "@mui/material";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import {
  applyJob,
  checkPersonIdCandidate,
  sendOTPCandidate,
} from "@Services/home";
import InputDateField from "@Molecule/InputDateField";
import Dropdown from "@Atom/DropDown";
import NewAutoComplete from "@Atom/NewAutoComplete";
import { useDropzone } from "react-dropzone";
import UploadBox from "@Atom/UploadBox";
import Radio from "@Atom/Radio";
import Checkbox from "@Atom/Checkbox";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import SUCCESS_GIF from "../../../../../../assets/Gifs/check.gif";
import { ListSkillsJobSeekers } from "@Helpers/listSkillsJobSeeker";
import AutocompleteV2 from "@Atom/AutocompleteV2";

const PDFJS = require("pdfjs-dist/webpack");

export default function ApplyJobModal({
  handleClose,
  data,
  modalApplyExternal,
  setPhoneNumber,
  phoneNumber,
  setVerificationState,
  verificationState,
  setHash,
  hash,
  valueStepOne,
  setValueStepOne,
  getListDropdown,
  getListLocation,
  setModalLinkVideo = () => {},
  valueCV,
  setValueCV,
  valueOptional,
  setValueOptional,
  setValueOptionalTemp,
  photoSelfie,
  setPhotoSelfie,
  setTigger = () => {},
  setSuccess = () => {},
}) {
  const [step, setStep] = useState(1);
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const handleChange = (e, name) => {
    if (name === "personId") {
      const numericValue = /^[0-9]*$/;
      if (!numericValue?.test(e)) {
        // Jika nilai tidak valid, kita tidak mengubah state
        return;
      }
    }

    if (name === "phoneNumber") {
      setValueStepOne((prev) => ({
        ...prev,
        isVerificationPhone: false,
      }));
    }
    setValueStepOne((prev) => ({
      ...prev,
      [name]: e,
    }));
  };

  const [isLoadingPersonId, setLoadingPersonId] = useState(false);

  useEffect(() => {
    const handleCheckPersonId = async () => {
      try {
        setLoadingPersonId(true);

        const { response } = await checkPersonIdCandidate({
          idNumber: valueStepOne?.personId,
        });

        if (response !== "ID Number is available") {
          const dataOTP = await sendOTPCandidate(response?.phoneNumber);

          setHash(dataOTP.response?.hash);
          setVerificationState("nrk");
          setPhoneNumber(response?.phoneNumber);
          setLoadingPersonId(false);

          setValueStepOne((prev) => ({
            ...prev,
            phoneNumber: response?.phoneNumber?.startsWith("62")
              ? response.phoneNumber.slice(2)
              : response?.phoneNumber || "",
            isValidated: true,
            isVerificationPhone: true,
            name: response?.name || "",
            email: response?.email || "",
            dateOfBirth: response?.dateOfBirth,
            gender: response?.gender || "",
            domicile: response?.domicile || "",
            address: response?.address || "",
            lastEducation: response?.lastEducation || "",
          }));
        } else {
          setValueStepOne((prev) => ({
            ...prev,
            isVerificationPhone: false,
            isValidated: true,
            isShowInput: true,
          }));
          setLoadingPersonId(false);
          setHash("");
          setVerificationState("");
          setPhoneNumber("");
        }
      } catch (error) {
        console.log(error);
        setLoadingPersonId(false);
      }
    };

    if (!valueStepOne?.isValidated && valueStepOne?.personId?.length === 16) {
      handleCheckPersonId();
    }

    if (valueStepOne?.isValidated && valueStepOne?.personId?.length < 16) {
      setValueStepOne((prev) => ({
        ...prev,
        isValidated: false,
        isShowInput: false,
      }));
    }
  }, [
    setHash,
    setPhoneNumber,
    setVerificationState,
    valueStepOne,
    setValueStepOne,
    // data,
  ]);

  const [isVerifying, setIsVerifying] = useState(false);
  const [errorVerifPhone, setErrorVerifPhone] = useState("");

  const onClickPhoneVerification = async () => {
    try {
      setIsVerifying(true);
      const data = await sendOTPCandidate("62" + valueStepOne?.phoneNumber);

      setIsVerifying(false);
      setHash(data.response?.hash);
      setVerificationState("phone");
      setPhoneNumber("62" + valueStepOne?.phoneNumber);
    } catch (err) {
      const errorMessage = err?.response?.data?.error || "something went wrong";
      setIsVerifying(false);
      if (errorMessage?.toLowerCase()?.includes("fill all field")) {
        setErrorVerifPhone(
          "Cek kembali form dan pastikan semua data telah terisi"
        );
      } else {
        setErrorVerifPhone(errorMessage);
      }
    }
  };

  const listTools = [
    {
      id: 1,
      desc: "Rekam video di tempat dengan pencahayaan yang baik dan suara yang jelas.",
    },
    {
      id: 2,
      desc: "Pastikan diri Anda berada di tengah frame dengan latar belakang yang rapi.",
    },
    {
      id: 3,
      desc: "Gunakan pakaian yang rapi dan sopan.",
    },
    {
      id: 4,
      desc: "Sebutkan nama, posisi, pengalaman kerja, dan alasan tertarik bekerja.",
    },
    {
      id: 5,
      desc: "Unggah video kamu melalui link Youtube, pastikan sebelumnya kamu telah menggunggah video pekenalan kamu di Youtube",
    },
  ];

  const arrayOfYear = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2000;
    const years = [];

    for (let year = startYear; year <= currentYear; year++) {
      years.push({ name: year });
    }
    return years.reverse();
  };

  const [errorFiles, setErrorFiles] = useState(null);

  const getRootPropsCV = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles?.length > 0) {
        const file = acceptedFiles[0];
        if (file?.type === "application/pdf" || file.name.endsWith(".pdf")) {
          setValueCV(acceptedFiles[0]);
          setErrorFiles(null);
        } else {
          setValueCV(null);
          setErrorFiles({
            type: "cv",
            msg: `File harus format pdf`,
          });
        }
      } else {
        setValueCV(null);
        setErrorFiles({
          type: "cv",
          msg: `File harus format pdf`,
        });
      }
    },
    accept: {
      "application/pdf": [".pdf"],
    },
    multiple: false,
    noClick: true,
  });

  const getRootPropsOptional = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles?.length > 0) {
        const file = acceptedFiles[0];

        if (file.type.startsWith("image/")) {
          setValueOptionalTemp(file);
          setErrorFiles(null);
        } else {
          setValueOptionalTemp(null);
          setErrorFiles({
            type: "optional",
            msg: `File harus format image`,
          });
        }
      } else {
        setValueOptionalTemp(null);
        setErrorFiles({
          type: "optional",
          msg: `File harus format image`,
        });
      }
    },
    multiple: false,
    noClick: true,
    accept: {
      // "application/pdf": [".pdf"],
      "image/jpeg": [],
      "image/jpg": [],
      "image/png": [],
    },
  });

  const [previewTemp, setPreviewTemp] = useState(null);

  const loadImageFromPDF = useCallback(async (url) => {
    // setUploading(true);
    var pdf = await PDFJS.getDocument({ url: url }).promise;
    const canvas = document.createElement("canvas");
    const images = [];
    for (let i = 0; i < pdf.numPages; i++) {
      const page = await pdf.getPage(i + 1);
      const viewport = page.getViewport({ scale: 1 });
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      await page.render({ canvasContext: context, viewport: viewport }).promise;
      images.push(canvas.toDataURL());
    }
    canvas.remove();
    setPreviewTemp(images[0]);
    // handleChangeForm("preview", images[0]);
    // setUploading(false);
  }, []);

  useEffect(() => {
    if (valueCV && valueCV instanceof File) {
      const objectUrl = URL.createObjectURL(valueCV);
      loadImageFromPDF(objectUrl);
    }
  }, [loadImageFromPDF, valueCV]);

  const [isCheck, setIsCheck] = useState(false);

  const disableNext = useMemo(() => {
    switch (step) {
      case 1:
        if (!valueStepOne?.personId) {
          return true;
        }

        if (!valueStepOne?.phoneNumber) {
          return true;
        }

        if (!valueStepOne?.name) {
          return true;
        }

        if (!valueStepOne?.email) {
          return true;
        }

        if (!valueStepOne?.dateOfBirth) {
          return true;
        }

        if (!valueStepOne?.gender) {
          return true;
        }

        if (!valueStepOne?.domicile) {
          return true;
        }

        if (!valueStepOne?.address) {
          return true;
        }

        if (!valueStepOne?.lastEducation) {
          return true;
        }

        if (valueStepOne?.skills?.length === 0) {
          return true;
        }

        if (data?.isSelfIntroVidDisplay && !valueStepOne?.videoLink) {
          return true;
        }

        if (!valueCV) {
          return true;
        }

        if (valueStepOne?.experiences?.length > 0) {
          for (
            let index = 0;
            index < valueStepOne?.experiences?.length;
            index++
          ) {
            const element = valueStepOne?.experiences[index];

            if (!element?.title) {
              return true;
            }

            if (!element?.clientName) {
              return true;
            }

            if (!element?.startMonth) {
              return true;
            }

            if (!element?.startYear) {
              return true;
            }

            if (!element?.isEmployeed && !element?.startYear) {
              return true;
            }

            if (!element?.isEmployeed && !element?.endYear) {
              return true;
            }

            if (!element?.remark) {
              return true;
            }

            // return false;
          }
        }

        if (
          !data?.isPhotoDisplay &&
          valueStepOne?.questions?.length === 0 &&
          !isCheck
        ) {
          return true;
        }

        return false;
      case 2:
        if (data?.isPhotoDisplay && !photoSelfie) {
          return true;
        }

        if (valueStepOne?.questions?.length > 0) {
          for (let index = 0; index < valueStepOne?.questions.length; index++) {
            const element = valueStepOne?.questions[index];

            if (element?.answerRequired && !element?.responseCandidate) {
              return true;
            }

            // return false;
          }
        }

        if (!isCheck) {
          return true;
        }

        return false;

      default:
        return false;
    }
  }, [step, valueStepOne, data, valueCV, photoSelfie, isCheck]);

  const handleChangePhoto = (e) => {
    if (e?.target?.files?.length > 0) {
      setPhotoSelfie(e?.target?.files[0]);
    }
  };

  const dropdownImage = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles?.length > 0) {
        const file = acceptedFiles[0];
        setPhotoSelfie(file);
      } else {
        setPhotoSelfie(null);
      }
    },
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
    multiple: false,
    maxSize: 1048576 * 5,
  });

  const [validate, setValidate] = useState(false);
  const [loadingApply, setLoadingApply] = useState(false);

  const targetElement = useRef();
  const scrollingTop = (event) => {
    const elmnt = targetElement;
    elmnt.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  };

  const [succesModal, setSuccesModal] = useState(false);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingApply(true);

      const formData = new FormData();
      if (localStorage?.getItem("accessTokenUserLanding")) {
        formData.append(
          "candidateAccountID",
          localStorage?.getItem("candidateID") || ""
        );
      }

      formData.append("jobPostID", data?._id || "");
      formData.append("idNumber", valueStepOne?.personId || "");
      formData.append("phoneNumber", "62" + valueStepOne?.phoneNumber || "");
      formData.append("name", valueStepOne?.name || "");
      formData.append("email", valueStepOne?.email || "");
      formData.append(
        "dateOfBirth",
        valueStepOne?.dateOfBirth
          ? moment(new Date(valueStepOne?.dateOfBirth)).format("YYYY=MM-DD")
          : ""
      );
      formData.append("gender", valueStepOne?.gender || "");
      formData.append("domicile", valueStepOne?.domicile || "");
      formData.append("address", valueStepOne?.address || "");
      formData.append("lastEducation", valueStepOne?.lastEducation || "");
      formData.append("introVideo", valueStepOne?.videoLink || "");

      if (valueStepOne?.experiences?.length > 0) {
        for (let i = 0; i < valueStepOne?.experiences?.length; i++) {
          const ecperience = valueStepOne?.experiences[i];

          formData.append(
            `experiences[${i}][jobTitle]`,
            ecperience?.title || ""
          );

          formData.append(
            `experiences[${i}][companyName]`,
            ecperience?.clientName || ""
          );

          formData.append(
            `experiences[${i}][startMonth]`,
            ecperience?.startMonth || ""
          );

          formData.append(
            `experiences[${i}][startYear]`,
            ecperience?.startYear || ""
          );

          formData.append(
            `experiences[${i}][endMonth]`,
            ecperience?.isEmployeed ? "-" : ecperience?.endMonth || "-"
          );

          formData.append(
            `experiences[${i}][endYear]`,
            ecperience?.isEmployeed ? "-" : ecperience?.endYear || "-"
          );
          formData.append(
            `experiences[${i}][isEmployed]`,
            ecperience?.isEmployeed ? "true" : "false"
          );

          formData.append(
            `experiences[${i}][description]`,
            ecperience?.remark || ""
          );
        }
      }

      if (valueStepOne?.skills?.length > 0) {
        for (let i = 0; i < valueStepOne?.skills?.length; i++) {
          const element = valueStepOne?.skills[i];
          formData.append(`skills[${i}]`, element?.name || "");
        }
      }

      formData?.append("CV", valueCV);

      if (valueOptional?.length > 0) {
        for (let i = 0; i < valueOptional.length; i++) {
          const element = valueOptional[i];
          formData.append(`accountDocuments[${i}][label]`, element?.type || "");
          formData.append(`accountDocuments[${i}][file]`, element?.file || "");
        }
      }

      if (data?.isPhotoDisplay) {
        formData?.append("selfie", photoSelfie);
      }

      if (valueStepOne?.questions?.length > 0) {
        for (let i = 0; i < valueStepOne?.questions?.length; i++) {
          const element = valueStepOne?.questions[i];

          formData?.append(`answers[${i}]`, element?.responseCandidate || "");
        }
      }

      if (!data?.isPhotoDisplay && valueStepOne?.questions?.length === 0) {
        if (disableNext) {
          setValidate(true);
          setLoadingApply(false);
          scrollingTop();
        } else {
          const { response } = await applyJob(formData);
          if (!localStorage?.getItem("accessTokenUserLanding")) {
            localStorage?.setItem(
              "accessTokenUserLanding",
              response?.accessToken
            );

            localStorage.setItem("nameUserLanding", response?.user?.name || "");
            localStorage.setItem(
              "phoneNumberUserLanding",
              response?.user?.phoneNumber || ""
            );
            localStorage.setItem(
              "emailUserLanding",
              response?.user?.email || ""
            );
            localStorage.setItem(
              "profilePictUserLanding",
              response?.user?.profilePic || ""
            );

            localStorage.setItem("dataProfile", "complete");
            localStorage.setItem(
              "personIdUserLanding",
              response?.user?.idNumber || ""
            );
            localStorage.setItem("candidateID", response?.user?.id || "");
            localStorage.setItem("isOtherClient", false);
            localStorage.setItem(
              "clientNameUserLanding",
              response?.user?.clientName || ""
            );
          }

          setSuccesModal(true);
          setTigger(Math.random());
          setValidate(false);
          setLoadingApply(false);
        }
      } else {
        if (disableNext) {
          setValidate(true);
          setLoadingApply(false);
          scrollingTop();
        } else {
          if (step !== 2) {
            setStep((prev) => prev + 1);
          } else {
            const { response } = await applyJob(formData);
            if (!localStorage?.getItem("accessTokenUserLanding")) {
              localStorage?.setItem(
                "accessTokenUserLanding",
                response?.accessToken
              );

              localStorage.setItem(
                "nameUserLanding",
                response?.user?.name || ""
              );
              localStorage.setItem(
                "phoneNumberUserLanding",
                response?.user?.phoneNumber || ""
              );
              localStorage.setItem(
                "emailUserLanding",
                response?.user?.email || ""
              );
              localStorage.setItem(
                "profilePictUserLanding",
                response?.user?.profilePic || ""
              );

              localStorage.setItem("dataProfile", "complete");
              localStorage.setItem(
                "personIdUserLanding",
                response?.user?.idNumber || ""
              );
              localStorage.setItem("candidateID", response?.user?.id || "");
              localStorage.setItem("isOtherClient", false);
              localStorage.setItem(
                "clientNameUserLanding",
                response?.user?.clientName || ""
              );
            }
            setSuccesModal(true);
            setTigger(Math.random());
          }
          setValidate(false);
          setLoadingApply(false);
        }
      }
    } catch (error) {
      console.log(error);
      setValidate(false);
      setLoadingApply(false);
    }
  };

  return succesModal ? (
    <div className={Styles.containerModalSuccess}>
      <div className={Styles.imageGif}>
        <img src={SUCCESS_GIF} alt="" />
      </div>

      <span className={Styles.bold}>Lamaran Terkirim</span>

      <span className={Styles.descSuccess}>
        Lamaran anda berhasil kami terima, mohon untuk menunggu proses
        selanjutnya. Silakan masuk menggunakan akun yang telah didaftarkan
        sebelumnya
      </span>

      <button
        className={Styles.buttonPrimary}
        onClick={() => {
          navigate(`/user/setting?fr=Perusahaan Lain`);
          setPhotoSelfie(null);
          setValueOptionalTemp(null);
          setValueCV(null);
          setValueOptional([]);
          setValueStepOne((prev) => ({
            ...prev,
            personId: "",
            phoneNumber: "",
            isVerificationPhone: false,
            isValidated: false,
            name: "",
            email: "",
            dateOfBirth: "",
            gender: "",
            domicile: "",
            address: "",
            lastEducation: "",
            videoLink: "",
            experiences: [],
            skills: [],
            isShowInput: false,
            questions: [],
          }));
          // handleClose();
        }}
      >
        Lihat Lamaran
      </button>
      <button
        className={Styles.buttonTransparant}
        onClick={() => {
          navigate("/job-seeker");
          setPhotoSelfie(null);
          setValueOptionalTemp(null);
          setValueCV(null);
          setValueOptional([]);
          setValueStepOne((prev) => ({
            ...prev,
            personId: "",
            phoneNumber: "",
            isVerificationPhone: false,
            isValidated: false,
            name: "",
            email: "",
            dateOfBirth: "",
            gender: "",
            domicile: "",
            address: "",
            lastEducation: "",
            videoLink: "",
            experiences: [],
            skills: [],
            isShowInput: false,
            questions: [],
          }));
        }}
      >
        Kembali ke Daftar Pekerjaan
      </button>
    </div>
  ) : (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <div className={Styles.leftHeader}>
          <div className={Styles.images}>
            <img src={Images.RESUME_ICON} alt="" />
          </div>

          <div className={Styles.descBox}>
            <span>Lamar ke</span>
            <span>{data?.title || "-"}</span>
          </div>
        </div>

        <div className={Styles.rightHeader} onClick={handleClose}>
          <Icon icon={"cross"} size={24} color={"#FFFFFF"} />
        </div>
      </div>

      <div className={Styles.content}>
        <div className={Styles.autoScroll} ref={targetElement} />

        <div className={Styles.stepInfo}>
          <span>
            Langkah {step || 1}/
            {!data?.isPhotoDisplay && valueStepOne?.questions?.length === 0
              ? "1"
              : "2"}
          </span>
        </div>

        {validate && (
          <div className={Styles.errorValidate}>
            <div>
              <Icon icon={"information-solid"} size={20} color={"#FF3E13"} />
            </div>

            <div>
              <span>Ada data yang belum diisi</span>
              <span>
                Silakan lengkapi data terlebih dahulu untuk dapat melanjutkan
              </span>
            </div>
          </div>
        )}
        {step === 1 ? (
          <div className={Styles.formWrapper}>
            <div className={Styles.formBox}>
              <span className={Styles.titleForm}>Informasi personal</span>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Nomor Induk Kependudukan (16 Digit)"}
                />

                <div className={Styles.nikInput}>
                  <InputField
                    isError={
                      (!valueStepOne?.personId && validate) ||
                      (valueStepOne?.personId?.length < 16 && validate)
                    }
                    placeholder={"Nomor Induk Kependudukan"}
                    value={valueStepOne?.personId}
                    onChange={(e) => {
                      if (e.target.value.length < 17) {
                        handleChange(e.target.value, "personId");
                      }
                    }}
                  />

                  {isLoadingPersonId && (
                    <div className={Styles.loadingPersonId}>
                      <Box sx={{ position: "relative" }}>
                        <CircularProgress
                          variant="determinate"
                          sx={{
                            color: (theme) =>
                              theme.palette.grey[
                                theme.palette.mode === "light" ? 200 : 800
                              ],
                          }}
                          size={20}
                          thickness={4}
                          value={100}
                        />
                        <CircularProgress
                          variant="indeterminate"
                          disableShrink
                          sx={{
                            color: (theme) =>
                              theme.palette.mode === "light"
                                ? "#1a90ff"
                                : "#308fe8",
                            animationDuration: "550ms",
                            position: "absolute",
                            left: 0,
                            [`& .${circularProgressClasses.circle}`]: {
                              strokeLinecap: "round",
                            },
                          }}
                          size={20}
                          thickness={4}
                        />
                      </Box>
                    </div>
                  )}
                </div>
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Nomor Whatsapp"}
                />

                <InputField
                  value={
                    valueStepOne?.isShowInput ? valueStepOne?.phoneNumber : ""
                  }
                  onChange={(e) => {
                    handleChange(e?.target?.value, "phoneNumber");
                  }}
                  disabled={
                    valueStepOne?.personId.length !== 16 ||
                    !valueStepOne?.isShowInput
                  }
                  placeholder={""}
                  type="phoneVerification"
                  isVerified={valueStepOne?.isVerificationPhone}
                  onClick={onClickPhoneVerification}
                  isLoading={isVerifying}
                  isError={
                    errorVerifPhone || (validate && !valueStepOne?.phoneNumber)
                  }
                  errorText={
                    validate && !valueStepOne?.phoneNumber
                      ? "Nomor Whatsapp wajib diisi"
                      : errorVerifPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Nama (Sesuai KTP)"}
                />

                <InputField
                  isError={
                    validate &&
                    !valueStepOne?.name &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  placeholder={"Nama sesuai KTP"}
                  value={
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                      ? valueStepOne?.name
                      : ""
                  }
                  onChange={(e) => {
                    const input = e.target;
                    const startPos = input.selectionStart;
                    const endPos = input.selectionEnd;
                    let newValue = input.value;

                    newValue = newValue.toUpperCase();
                    handleChange(newValue, "name");
                    setTimeout(() => {
                      if (document.activeElement === input) {
                        input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
                      }
                    }, 0);
                  }}
                  disabled={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Email"}
                />

                <InputField
                  isError={
                    validate &&
                    !valueStepOne?.email &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  placeholder={"example@mail.com"}
                  value={
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                      ? valueStepOne?.email
                      : ""
                  }
                  onChange={(e) => {
                    const input = e.target;
                    const startPos = input.selectionStart;
                    const endPos = input.selectionEnd;
                    let newValue = input.value;

                    newValue = newValue.toLowerCase()?.trim();
                    handleChange(newValue, "email");
                    setTimeout(() => {
                      if (document.activeElement === input) {
                        input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
                      }
                    }, 0);
                  }}
                  disabled={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Tanggal lahir"}
                />

                <InputDateField
                  autoClose
                  isError={
                    validate &&
                    !valueStepOne?.dateOfBirth &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  placeholder={"Tanggal lahir"}
                  value={
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                      ? valueStepOne?.dateOfBirth
                      : ""
                  }
                  setValue={(e) => {
                    handleChange(e, "dateOfBirth");
                  }}
                  disabled={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Jenis Kelamin"}
                />

                <Dropdown
                  isError={
                    validate &&
                    !valueStepOne?.gender &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  errorText="Please fill the field"
                  autoClose
                  placeholder={"Pilih salah satu"}
                  value={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                      ? ""
                      : valueStepOne?.gender
                  }
                  setValue={(e) => {
                    handleChange(e, "gender");
                  }}
                  options={
                    getListDropdown
                      ?.filter((el) => el?.type === "Gender")
                      ?.map((el) => {
                        return {
                          name: el?.value,
                        };
                      }) || []
                  }
                  viewOnly={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Domisili (Tempat Tinggal Sekarang)"}
                />

                <AutocompleteV2
                  isErrorText={
                    validate &&
                    !valueStepOne?.domicile &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  isError={
                    validate &&
                    !valueStepOne?.domicile &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  errorText="Please fill the field"
                  autoClose
                  placeholder={"Pilih salah satu"}
                  value={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                      ? ""
                      : valueStepOne?.domicile
                  }
                  setValue={(e) => {
                    handleChange(e, "domicile");
                  }}
                  options={
                    getListLocation?.map((el) => {
                      return {
                        name: el?.name,
                      };
                    }) || []
                  }
                  viewOnly={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Alamat"}
                />

                <InputField
                  isError={
                    validate &&
                    !valueStepOne?.address &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  type={"desc"}
                  placeholder={"Tulis alamat anda"}
                  value={
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                      ? valueStepOne?.address
                      : ""
                  }
                  onChange={(e) => {
                    const input = e.target;
                    const startPos = input.selectionStart;
                    const endPos = input.selectionEnd;
                    let newValue = input.value;

                    newValue = newValue.toUpperCase();
                    handleChange(newValue, "address");
                    setTimeout(() => {
                      if (document.activeElement === input) {
                        input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
                      }
                    }, 0);
                  }}
                  disabled={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Pendidikan Terakhir"}
                />

                <Dropdown
                  isError={
                    validate &&
                    !valueStepOne?.lastEducation &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  errorText="Please fill the field"
                  autoClose
                  placeholder={"Pilih salah satu"}
                  value={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                      ? ""
                      : valueStepOne?.lastEducation
                  }
                  setValue={(e) => {
                    handleChange(e, "lastEducation");
                  }}
                  options={
                    getListDropdown
                      ?.filter((el) => el?.type === "Education")
                      ?.map((el) => {
                        return {
                          name: el?.value,
                        };
                      }) || []
                  }
                  viewOnly={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                />
              </div>
            </div>

            <div
              className={`${Styles.formBox} ${
                validate &&
                data?.isSelfIntroVidDisplay &&
                !valueStepOne?.videoLink &&
                Styles.error
              }`}
            >
              <div className={`${Styles.form}`}>
                <div className={Styles.titleBox}>
                  <InputTitle
                    title={"Video Perkenalan Diri"}
                    required={data?.isSelfIntroVidDisplay}
                    requiredLabel={data?.isSelfIntroVidDisplay && "Wajib diisi"}
                  />

                  {!valueStepOne?.videoLink && (
                    <div className={Styles.warningVideo}>
                      <Icon
                        icon={"information-solid"}
                        size={16}
                        color={"#F28609"}
                      />
                      <span>Video perkenalan belum diunggah</span>
                    </div>
                  )}
                </div>

                <div className={Styles.descVideo}>
                  <span className={Styles.span1}>
                    Buat video perkenalan diri kamu, biar kamu lebih dikenal
                    oleh rekruter! Silahkan baca arahan dibawah ini:
                  </span>

                  <div className={Styles.listTools}>
                    {listTools?.map((el, idx) => {
                      return (
                        <div key={idx}>
                          <div className={Styles.bullet}></div>
                          <span>{el?.desc || "-"}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={Styles.cvBox}>
                  <div className={Styles.leftCv}>
                    <div className={Styles.icon}>
                      <Icon
                        icon={"video-outline"}
                        size={24}
                        color={"#1571DE"}
                      />
                    </div>

                    <span
                      className={`${valueStepOne?.videoLink && Styles.blue}`}
                      onClick={() => {
                        if (valueStepOne?.videoLink) {
                          window.open(valueStepOne?.videoLink);
                        }
                      }}
                    >
                      {valueStepOne?.videoLink ||
                        "Belum ada video yang ditambahkan"}
                    </span>
                  </div>

                  <div className={Styles.rightCv}>
                    <button
                      disabled={
                        !valueStepOne?.isShowInput ||
                        !valueStepOne?.isVerificationPhone
                      }
                      onClick={() => {
                        if (
                          !valueStepOne?.isShowInput ||
                          !valueStepOne?.isVerificationPhone
                        ) {
                          return;
                        } else {
                          setModalLinkVideo(true);
                        }
                      }}
                    >
                      <Icon
                        icon={valueStepOne?.videoLink ? "return" : "upload"}
                        size={20}
                        className={Styles.iconUUpload}
                      />
                      {valueStepOne?.videoLink ? "Perbaharui" : "Masukan Link"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className={Styles.formBox}>
              <div className={`${Styles.form}`}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Pengalaman Kerja"}
                />

                <div className={Styles.buttonSelectionBox}>
                  <button
                    disabled={
                      !valueStepOne?.isShowInput ||
                      !valueStepOne?.isVerificationPhone
                    }
                    className={`${
                      valueStepOne?.experiences?.length > 0 && Styles.active
                    }`}
                    onClick={() => {
                      if (valueStepOne?.experiences?.length > 0) {
                        return;
                      } else {
                        setValueStepOne((prev) => ({
                          ...prev,
                          experiences: [
                            ...valueStepOne?.experiences,
                            {
                              id: Math.random(),
                              title: "",
                              clientName: "",
                              startMonth: "",
                              startYear: "",
                              endMonth: "",
                              endYear: "",
                              isEmployeed: false,
                              remark: "",
                            },
                          ],
                        }));
                      }
                    }}
                  >
                    Memiliki Pengalaman
                  </button>
                  <button
                    disabled={
                      !valueStepOne?.isShowInput ||
                      !valueStepOne?.isVerificationPhone
                    }
                    className={`${
                      valueStepOne?.experiences?.length === 0 && Styles.active
                    }`}
                    onClick={() => {
                      if (valueStepOne?.experiences?.length === 0) {
                        return;
                      } else {
                        setValueStepOne((prev) => ({
                          ...prev,
                          experiences: [],
                        }));
                      }
                    }}
                  >
                    Tanpa Pengalaman
                  </button>
                </div>

                <div className={Styles.experiencesBox}>
                  {valueStepOne?.experiences?.map((el, idx) => {
                    return (
                      <div key={idx}>
                        <div className={Styles.left}>
                          <div className={Styles.form}>
                            <InputTitle
                              required
                              requiredLabel="Wajib diisi"
                              title={"Posisi"}
                            />

                            <InputField
                              isError={
                                validate &&
                                !el?.title &&
                                valueStepOne?.isShowInput &&
                                valueStepOne?.isVerificationPhone
                              }
                              disabled={
                                !valueStepOne?.isShowInput ||
                                !valueStepOne?.isVerificationPhone
                              }
                              placeholder={"Contoh: Security"}
                              value={el?.title}
                              onChange={(e) => {
                                const input = e.target;
                                const startPos = input.selectionStart;
                                const endPos = input.selectionEnd;
                                let newValue = input.value;

                                newValue = newValue.toUpperCase();

                                const updatedValue =
                                  valueStepOne?.experiences?.map((item) => {
                                    if (item?.id === el?.id) {
                                      return {
                                        ...item,
                                        title: newValue,
                                      };
                                    } else {
                                      return item;
                                    }
                                  });

                                handleChange(updatedValue, "experiences");

                                setTimeout(() => {
                                  if (document.activeElement === input) {
                                    input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
                                  }
                                }, 0);
                              }}
                            />
                          </div>
                          <div className={Styles.form}>
                            <InputTitle
                              required
                              requiredLabel="Wajib diisi"
                              title={"Nama Perusahaan"}
                            />

                            <InputField
                              disabled={
                                !valueStepOne?.isShowInput ||
                                !valueStepOne?.isVerificationPhone
                              }
                              isError={
                                validate &&
                                !el?.clientName &&
                                valueStepOne?.isShowInput &&
                                valueStepOne?.isVerificationPhone
                              }
                              placeholder={"Contoh: Pt Maju Jaya"}
                              value={el?.clientName}
                              onChange={(e) => {
                                const input = e.target;
                                const startPos = input.selectionStart;
                                const endPos = input.selectionEnd;
                                let newValue = input.value;

                                newValue = newValue.toUpperCase();

                                const updatedValue =
                                  valueStepOne?.experiences?.map((item) => {
                                    if (item?.id === el?.id) {
                                      return {
                                        ...item,
                                        clientName: newValue,
                                      };
                                    } else {
                                      return item;
                                    }
                                  });

                                handleChange(updatedValue, "experiences");

                                setTimeout(() => {
                                  if (document.activeElement === input) {
                                    input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
                                  }
                                }, 0);
                              }}
                            />
                          </div>

                          <div className={Styles.inputDateContainer}>
                            <div className={Styles.dateInputWrapper}>
                              <InputTitle
                                required
                                requiredLabel="Wajib diisi"
                                title={"Mulai"}
                              />

                              <div className={Styles.inputDate}>
                                <Dropdown
                                  viewOnly={
                                    !valueStepOne?.isShowInput ||
                                    !valueStepOne?.isVerificationPhone
                                  }
                                  isError={
                                    validate &&
                                    !el?.startMonth &&
                                    valueStepOne?.isShowInput &&
                                    valueStepOne?.isVerificationPhone
                                  }
                                  placeholder={"Bulan"}
                                  options={[
                                    { name: "Januari" },
                                    { name: "Februari" },
                                    { name: "Maret" },
                                    { name: "April" },
                                    { name: "Mei" },
                                    { name: "Juni" },
                                    { name: "Juli" },
                                    { name: "Agustus" },
                                    { name: "September" },
                                    { name: "Oktober" },
                                    { name: "November" },
                                    { name: "Desember" },
                                  ]}
                                  value={el.startMonth}
                                  setValue={(e) => {
                                    const updatedValue =
                                      valueStepOne?.experiences?.map((item) => {
                                        if (item?.id === el?.id) {
                                          return {
                                            ...item,
                                            startMonth: e,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });

                                    handleChange(updatedValue, "experiences");
                                  }}
                                  autoClose

                                  //  iconColor={iconColor}
                                />
                                <Dropdown
                                  viewOnly={
                                    !valueStepOne?.isShowInput ||
                                    !valueStepOne?.isVerificationPhone
                                  }
                                  isError={
                                    validate &&
                                    !el?.startYear &&
                                    valueStepOne?.isShowInput &&
                                    valueStepOne?.isVerificationPhone
                                  }
                                  placeholder={"Tahun"}
                                  options={arrayOfYear()}
                                  value={el.startYear}
                                  setValue={(e) => {
                                    const updatedValue =
                                      valueStepOne?.experiences?.map((item) => {
                                        if (item?.id === el?.id) {
                                          return {
                                            ...item,
                                            startYear: e,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });

                                    handleChange(updatedValue, "experiences");
                                  }}
                                  autoClose

                                  //  iconColor={iconColor}
                                />
                              </div>
                            </div>

                            <div className={Styles.dateInputWrapper}>
                              <InputTitle
                                required
                                requiredLabel="Wajib diisi"
                                title={"Berakhir"}
                              />

                              <div className={Styles.inputDate}>
                                <Dropdown
                                  viewOnly={
                                    !valueStepOne?.isShowInput ||
                                    !valueStepOne?.isVerificationPhone
                                  }
                                  isError={
                                    validate &&
                                    !el?.endMonth &&
                                    !el?.isEmployeed &&
                                    valueStepOne?.isShowInput &&
                                    valueStepOne?.isVerificationPhone
                                  }
                                  placeholder={"Bulan"}
                                  options={[
                                    { name: "Januari" },
                                    { name: "Februari" },
                                    { name: "Maret" },
                                    { name: "April" },
                                    { name: "Mei" },
                                    { name: "Juni" },
                                    { name: "Juli" },
                                    { name: "Agustus" },
                                    { name: "September" },
                                    { name: "Oktober" },
                                    { name: "November" },
                                    { name: "Desember" },
                                  ]}
                                  value={el.endMonth}
                                  disabled={el?.isEmployeed}
                                  setValue={(e) => {
                                    const updatedValue =
                                      valueStepOne?.experiences?.map((item) => {
                                        if (item?.id === el?.id) {
                                          return {
                                            ...item,
                                            endMonth: e,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });

                                    handleChange(updatedValue, "experiences");
                                  }}
                                  autoClose

                                  //  iconColor={iconColor}
                                />
                                <Dropdown
                                  viewOnly={
                                    !valueStepOne?.isShowInput ||
                                    !valueStepOne?.isVerificationPhone
                                  }
                                  isError={
                                    validate &&
                                    !el?.endYear &&
                                    !el?.isEmployeed &&
                                    valueStepOne?.isShowInput &&
                                    valueStepOne?.isVerificationPhone
                                  }
                                  disabled={el?.isEmployeed}
                                  placeholder={"Tahun"}
                                  options={arrayOfYear()}
                                  value={el.endYear}
                                  setValue={(e) => {
                                    const updatedValue =
                                      valueStepOne?.experiences?.map((item) => {
                                        if (item?.id === el?.id) {
                                          return {
                                            ...item,
                                            endYear: e,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });

                                    handleChange(updatedValue, "experiences");
                                  }}
                                  autoClose

                                  //  iconColor={iconColor}
                                />
                              </div>

                              <div className={Styles.checkBox}>
                                <input
                                  type="checkbox"
                                  checked={el?.isEmployeed}
                                  onChange={(e) => {
                                    const updatedValue =
                                      valueStepOne?.experiences?.map((item) => {
                                        if (item?.id === el?.id) {
                                          return {
                                            ...item,
                                            endMonth: "",
                                            endYear: "",
                                            isEmployeed: e.target.checked,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });

                                    handleChange(updatedValue, "experiences");
                                  }}
                                />
                                <p>Masih bekerja hingga saat ini</p>
                              </div>
                            </div>
                          </div>

                          <div className={Styles.form}>
                            <InputField
                              type={"desc"}
                              disabled={
                                !valueStepOne?.isShowInput ||
                                !valueStepOne?.isVerificationPhone
                              }
                              isError={
                                validate &&
                                !el?.remark &&
                                valueStepOne?.isShowInput &&
                                valueStepOne?.isVerificationPhone
                              }
                              placeholder={"Deskripsi"}
                              value={el?.remark}
                              onChange={(e) => {
                                const input = e.target;
                                const startPos = input.selectionStart;
                                const endPos = input.selectionEnd;
                                let newValue = input.value;

                                newValue = newValue.toUpperCase();

                                const updatedValue =
                                  valueStepOne?.experiences?.map((item) => {
                                    if (item?.id === el?.id) {
                                      return {
                                        ...item,
                                        remark: newValue,
                                      };
                                    } else {
                                      return item;
                                    }
                                  });

                                handleChange(updatedValue, "experiences");

                                setTimeout(() => {
                                  if (document.activeElement === input) {
                                    input.setSelectionRange(startPos, endPos); // Pastikan input masih fokus sebelum set cursor
                                  }
                                }, 0);
                              }}
                            />
                          </div>
                        </div>

                        <div
                          className={`${Styles.right} ${
                            valueStepOne?.experiences?.length === 1 &&
                            Styles.disabled
                          }`}
                          onClick={() => {
                            if (valueStepOne?.experiences?.length > 1) {
                              const updatedValue =
                                valueStepOne?.experiences?.filter(
                                  (item) => el?.id !== item?.id
                                );

                              handleChange(updatedValue, "experiences");
                            }
                          }}
                        >
                          <div className={Styles.iconDelete}>
                            <Icon
                              icon={"trash"}
                              size={20}
                              color={
                                valueStepOne?.experiences?.length === 1
                                  ? "#C2C2C2"
                                  : "#FFFFFF"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {valueStepOne?.experiences?.length > 0 && (
                    <button
                      className={Styles.addExperiences}
                      onClick={() => {
                        setValueStepOne((prev) => ({
                          ...prev,
                          experiences: [
                            ...valueStepOne?.experiences,
                            {
                              id: Math.random(),
                              title: "",
                              clientName: "",
                              startMonth: "",
                              startYear: "",
                              endMonth: "",
                              endYear: "",
                              isEmployeed: false,
                              remark: "",
                            },
                          ],
                        }));
                      }}
                    >
                      <Icon icon={"add-circle"} size={16} color={"#1571DE"} />
                      Tambah Pengalaman Pekerjaan
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className={Styles.formBox}>
              <span className={Styles.titleForm}>CV</span>

              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Unggah CV"}
                />

                {valueStepOne?.isShowInput &&
                valueStepOne?.isVerificationPhone ? (
                  <div
                    className={Styles.uploadDoc}
                    {...getRootPropsCV?.getRootProps()}
                  >
                    <input
                      {...getRootPropsCV.getInputProps()}
                      type="file"
                      name="file"
                      hidden
                      accept="application/pdf"
                    />
                    <UploadBox
                      isError={
                        errorFiles?.type === "cv" ||
                        (validate &&
                          !valueCV &&
                          valueStepOne?.isShowInput &&
                          valueStepOne?.isVerificationPhone)
                      }
                      // isError={(validate && !files && !formStepFive) || errorFiles}
                      onClick={getRootPropsCV?.open}
                      isPdf={true}
                      isUploaded={valueCV}
                      fileName={valueCV?.name}
                      fileImage={previewTemp}
                    />
                  </div>
                ) : (
                  <div className={Styles.uploadDoc}>
                    <UploadBox
                      // isError={(validate && !files && !formStepFive) || errorFiles}
                      disabled
                      isPdf={true}
                    />
                  </div>
                )}

                {(validate &&
                  !valueCV &&
                  valueStepOne?.isShowInput &&
                  valueStepOne?.isVerificationPhone) ||
                errorFiles?.type === "cv" ? (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "red",
                    }}
                  >
                    *
                    {errorFiles?.type === "cv"
                      ? errorFiles?.msg
                      : "Dokumen wajib diisi"}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className={Styles.formBox}>
              <span className={Styles.titleForm}>Dokumen Lainnya</span>

              <div className={Styles.form}>
                <InputTitle title={"Unggah Dokumen Lainnya (Maksimal 30 MB)"} />
                {valueStepOne?.isShowInput &&
                valueStepOne?.isVerificationPhone ? (
                  <div
                    className={Styles.uploadDoc}
                    {...getRootPropsOptional?.getRootProps()}
                  >
                    <input
                      {...getRootPropsOptional.getInputProps()}
                      type="file"
                      name="file"
                      hidden
                      accept="image/*"
                    />
                    <UploadBox
                      isError={errorFiles?.type === "optional"}
                      isPdf={false}
                      onClick={getRootPropsOptional?.open}
                    />
                  </div>
                ) : (
                  <div className={Styles.uploadDoc}>
                    <UploadBox disabled isPdf={false} />
                  </div>
                )}

                {errorFiles?.type === "optional" && (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "red",
                    }}
                  >
                    *{errorFiles?.msg}
                  </span>
                )}

                {valueOptional?.length > 0 &&
                  valueOptional?.map((el, idx) => (
                    <div key={idx} className={Styles.cardDocuments}>
                      <InputTitle title={el?.type || "-"} />
                      <div className={Styles.card}>
                        <span>{el?.name}</span>
                        <button
                          onClick={() => {
                            const updateValue = valueOptional?.filter(
                              (item) => item?.id !== el?.id
                            );
                            setValueOptional(updateValue);
                          }}
                        >
                          <Icon icon="cross-circle" size={18} />
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className={Styles.formBox}>
              <span className={Styles.titleForm}>Skills yang Dimiliki</span>
              <div className={Styles.form}>
                <InputTitle
                  required
                  requiredLabel="Wajib diisi"
                  title={"Pilih skill yang kamu miliki"}
                />
                <NewAutoComplete
                  isError={
                    validate &&
                    valueStepOne?.skills?.length === 0 &&
                    valueStepOne?.isShowInput &&
                    valueStepOne?.isVerificationPhone
                  }
                  disabled={
                    !valueStepOne?.isShowInput ||
                    !valueStepOne?.isVerificationPhone
                  }
                  onResetAll={() => {
                    setValueStepOne((prev) => ({
                      ...prev,
                      skills: [],
                    }));
                  }}
                  selectedItem={valueStepOne?.skills || []}
                  onReset={(e) => {
                    const updatedValue = valueStepOne?.skills?.filter(
                      (el) => el?.name !== e?.name
                    );

                    handleChange(updatedValue, "skills");
                  }}
                  onClickOption={(e) => {
                    if (
                      !valueStepOne?.skills?.find((el) => el?.name === e?.name)
                    ) {
                      setValueStepOne((prev) => ({
                        ...prev,
                        skills: [
                          ...prev?.skills,
                          {
                            ...e,
                          },
                        ],
                      }));
                    }
                  }}
                  placeholder={"Pilih skill"}
                  value={value}
                  setValue={setValue}
                  options={ListSkillsJobSeekers() || []}
                  maxHeight={"70px"}
                />
              </div>
            </div>

            {!data?.isPhotoDisplay && valueStepOne?.questions?.length === 0 && (
              <div className={Styles.checkbox}>
                <Checkbox
                  type={"job-post"}
                  isChecked={isCheck}
                  setIsChecked={setIsCheck}
                  isError={validate && !isCheck}
                />
                <span>
                  Dengan melamar pekerjaan, Anda menyetujui{" "}
                  <span>Kebijakan Privasi</span> PT Permata Indo Sejahtera, dan
                  secara otomatis akun kamu akan dibuat secara otomatis
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className={Styles.formWrapper}>
            {data?.isPhotoDisplay && (
              <div className={Styles.photoSelfieBox}>
                {photoSelfie ? (
                  <div className={Styles.ImageidContainer}>
                    <img src={URL.createObjectURL(photoSelfie)} alt="imageid" />
                    <div
                      className={Styles.Footer}
                      {...dropdownImage.getRootProps()}
                    >
                      <Icon icon={"camera"} size="24px" />
                      <p>Foto Ulang</p>
                      <input
                        {...dropdownImage.getInputProps()}
                        type="file"
                        // ref={inputFileRef}
                        name="file"
                        onChange={handleChangePhoto}
                        hidden
                        accept="image/*"
                        capture="user"
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${Styles.dropdownSection} ${
                      validate && !photoSelfie && Styles.error
                    }`}
                    {...dropdownImage.getRootProps()}
                  >
                    <Icon icon="camera" size={28} color={"#1571DE"} />
                    <div>
                      <span className={Styles.label}>Ambil Foto Selfie</span>
                      <span className={Styles.requiredLabel}>Wajib Diisi</span>
                    </div>

                    <input
                      {...dropdownImage.getInputProps()}
                      type="file"
                      // ref={inputFileRef}
                      name="file"
                      onChange={handleChangePhoto}
                      hidden
                      accept="image/*"
                      capture="user"
                    />
                  </div>
                )}
              </div>
            )}

            {valueStepOne?.questions?.length > 0 && (
              <div className={Styles.questionsBox}>
                {valueStepOne?.questions?.map((el, idx) => {
                  return (
                    <div className={Styles.form} key={idx}>
                      <InputTitle
                        title={el?.label || "-"}
                        required={el?.answerRequired}
                        requiredLabel="Wajib diisi"
                      />

                      {el?.type === "Numerik" && (
                        <InputField
                          isError={validate && !el?.responseCandidate}
                          type={"number"}
                          placeholder={"Masukan jawaban kamu"}
                          value={el?.responseCandidate}
                          onChange={(e) => {
                            const updateValue = valueStepOne?.questions?.map(
                              (item) => {
                                if (item?.label === el?.label) {
                                  return {
                                    ...item,
                                    responseCandidate: e?.target?.value,
                                  };
                                } else {
                                  return item;
                                }
                              }
                            );

                            setValueStepOne((prev) => ({
                              ...prev,
                              questions: updateValue,
                            }));
                          }}
                        />
                      )}

                      {el?.type === "Isian Singkat" && (
                        <InputField
                          isError={validate && !el?.responseCandidate}
                          placeholder={"Masukan jawaban kamu"}
                          value={el?.responseCandidate}
                          onChange={(e) => {
                            const updateValue = valueStepOne?.questions?.map(
                              (item) => {
                                if (item?.label === el?.label) {
                                  return {
                                    ...item,
                                    responseCandidate: e?.target?.value,
                                  };
                                } else {
                                  return item;
                                }
                              }
                            );

                            setValueStepOne((prev) => ({
                              ...prev,
                              questions: updateValue,
                            }));
                          }}
                        />
                      )}

                      {el.type === "Paragraf" && (
                        <InputField
                          isError={validate && !el?.responseCandidate}
                          type={"desc"}
                          placeholder={"Masukan jawaban kamu"}
                          value={el?.responseCandidate}
                          onChange={(e) => {
                            const updateValue = valueStepOne?.questions?.map(
                              (item) => {
                                if (item?.label === el?.label) {
                                  return {
                                    ...item,
                                    responseCandidate: e?.target?.value,
                                  };
                                } else {
                                  return item;
                                }
                              }
                            );

                            setValueStepOne((prev) => ({
                              ...prev,
                              questions: updateValue,
                            }));
                          }}
                        />
                      )}

                      {el.type === "Tanggal" && (
                        <InputDateField
                          autoClose
                          isError={validate && !el?.responseCandidate}
                          placeholder={"Masukan jawaban kamu"}
                          value={el?.responseCandidate}
                          setValue={(e) => {
                            const updateValue = valueStepOne?.questions?.map(
                              (item) => {
                                if (item?.label === el?.label) {
                                  return {
                                    ...item,
                                    responseCandidate: e,
                                  };
                                } else {
                                  return item;
                                }
                              }
                            );

                            setValueStepOne((prev) => ({
                              ...prev,
                              questions: updateValue,
                            }));
                          }}
                        />
                      )}

                      {el?.type === "Pilihan" && (
                        <div className={Styles.questionsChooseBox}>
                          {el?.answerOptions?.map((quest, idQuest) => {
                            return (
                              <div key={idQuest}>
                                <Radio
                                  isError={validate && !el?.responseCandidate}
                                  isChecked={
                                    el?.responseCandidate === quest?.value
                                  }
                                  setIsChecked={() => {
                                    const updateValue =
                                      valueStepOne?.questions?.map((item) => {
                                        if (item?.label === el?.label) {
                                          return {
                                            ...item,
                                            responseCandidate: quest.value,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });

                                    setValueStepOne((prev) => ({
                                      ...prev,
                                      questions: updateValue,
                                    }));
                                  }}
                                />
                                <span>{quest?.value || "-"}</span>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            <div className={Styles.checkbox}>
              <Checkbox
                type={"job-post"}
                isChecked={isCheck}
                setIsChecked={setIsCheck}
                isError={validate && !isCheck}
              />
              <span>
                Dengan melamar pekerjaan, Anda menyetujui{" "}
                <span>Kebijakan Privasi</span> PT Permata Indo Sejahtera, dan
                secara otomatis akun kamu akan dibuat secara otomatis
              </span>
            </div>
          </div>
        )}

        <div className={Styles.buttonsWrapper}>
          {/* <span>*error</span> */}
          <div className={Styles.button}>
            {step === 2 && (
              <button
                className={`${Styles.back}`}
                disabled={loadingApply}
                onClick={() => {
                  setStep((prev) => prev - 1);
                }}
              >
                Kembali
              </button>
            )}

            <button
              onClick={handleSubmit}
              disabled={
                !valueStepOne?.isShowInput ||
                !valueStepOne?.isVerificationPhone ||
                loadingApply
              }
              className={`${Styles.next}`}
            >
              {loadingApply
                ? "Loading..."
                : !data?.isPhotoDisplay && valueStepOne?.questions?.length === 0
                ? "Kirim Lamaran"
                : "Lanjut"}
            </button>
          </div>
        </div>
      </div>

      {!localStorage?.getItem("accessTokenUserLanding") && (
        <div className={Styles.footerLogin}>
          <div>
            Sudah memiliki akun?{" "}
            <span
              onClick={() => {
                navigate(`/user/login?fr=${data?._id}`);
              }}
            >
              Masuk
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
